var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconGoldStar = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  x: "0px",
  y: "0px",
  viewBox: "0 0 31.6 30.1",
  style: {
    enableBackground: "new 0 0 31.6 30.1"
  },
  xmlSpace: "preserve",
  className: "icon icon--gold-star",
  ref: svgRef
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFA000;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M0.8,11.7l7.4,7.2c0.1,0.1,0.2,0.3,0.1,0.4L6.5,29.3l9.1-4.8c0.1-0.1,0.3-0.1,0.4,0l9.1,4.8l-1.7-10.1 c0-0.1,0-0.3,0.1-0.4l7.4-7.2l-10.2-1.5c-0.1,0-0.3-0.1-0.3-0.2l-4.5-9.2l-4.5,9.2c-0.1,0.1-0.2,0.2-0.3,0.2L0.8,11.7z"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconGoldStar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/IconGoldStar.c4b84649.svg";
export { ForwardRef as ReactComponent };